<template>
    <div class='upload'>
        <el-row>
            <el-col :span="12">
                <div class="upload-item">
                    <a href="javascript:;" class="file">
                        <input id="file_head" type="file" accept="image/*" capture="camera" @change="setImagePreview()">
                        <span class="text">拍照</span>
                    </a>
                </div>
            </el-col>
            <el-col :span="12" style="text-align: center">
                <div class="upload-item">
                    <a href="javascript:;" class="file file2">
                        <input id="file_head2" type="file" @change="setFilePreview()">
                        <span class="text">文件</span>
                    </a>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import * as Urls from '../helper/Urls';
import * as VueHelper from '@/helper/VueHelper';
import axios from 'axios';
import OSS from 'ali-oss';
import wx from 'weixin-js-sdk';
import qs from 'qs';
import { Toast } from 'vant';

export default {
    data(){
        return{
            dirId: '',
            fileType: 1,
            phone: '',
            projectId: '',
            client:new OSS({
                region: 'oss-cn-shenzhen',
                accessKeyId: 'LTAI4GGHb3kkSnv9MdPdPb4Y',
                accessKeySecret: 'yEOrbRYDSIJpgjGiZk9yTsuSAyava9',
                bucket: 'xmoty',
                timeout: 600000
            }),
            dataList:[],
            delId:'',
            toast: null,
            JumpLogo:'',
            ext: ['jpg','jpeg','png','bmp','gif','pdf','doc','docx','xls','xlsx','zip','rar'],
        }
    },
    mounted(){
        this.dirId = this.$route.query.dirId;
        this.phone = this.$route.query.phone;
        this.projectId = this.$route.query.projectId;
        this.JumpLogo  = this.$route.query.JumpLogo
        console.log(this.$route.query)
        this.authorizationToAppJump();
    },
    methods:{
        authorizationToAppJump() {
            let inst = this;
            let url = Urls.authorizationToAppJump;
            let params = {
                phone: this.phone,
            };
            this.$root.doPost(url,params,function(server_data){
                    
                // 用户没有登录
                if( ! inst.$root.isUserLogin(server_data)){
                    return;
                }

                // 应用错误
                if(server_data.error){
                    alert(server_data.error)
                    // inst.$root.showGlobalError(server_data.error);
                    return;
                }

                inst.token = server_data.data.token;
            });
        },
        saveDocFileBatch() {
            let list = this.dataList.map(e => {
                let obj = {
                    iconUrl: e.iconUrl,
                    fileSize: e.fileSize,
                    fileFormat: e.fileFormat,
                    fileUrl: e.fileUrl,
                    fileName: e.fileName,
                    originalName: e.name
                }
                return obj;
            });
            
            let inst = this;
            let url = Urls.project_saveDocFileBatch;
            let params = {
                dirId: this.dirId,
                fileType: this.fileType,
                projectDocFiles: JSON.stringify(list)
            };

            axios({
                url: url,
                method: 'post',
                data: qs.stringify(params),
                headers:{
                    'Authorization': this.token
                }
            }).then((res => {
                // 应用错误
                if(res.data.error){
                    alert(res.data.error);
                    return;
                }
                this.toast.clear();
                if(this.JumpLogo == 'WithData'){
                wx.miniProgram.redirectTo({
                    url:'/pages/packageInfo/pages/projectInFormation/main?id=' + this.projectId 
                })
                }else{      
                wx.miniProgram.redirectTo({
                    url:'/pages/packageInfo/pages/projectDetail/main?id=' + this.projectId + '&activeIndex=2'
                })
                }
            }));
        },
        setImagePreview() {
            this.fileType = 2;
			var file_head = document.getElementById("file_head")
            var file = file_head.files[0];
            file.uid = file.lastModified;
			console.log(file_head.files[0].lastModified)
            var content = {
                file: file
            }
            this.myUpload(content);
		},
        setFilePreview() {
            this.fileType = 1;
			var file_head2 = document.getElementById("file_head2")
            var file = file_head2.files[0];
            file.uid = file.lastModified;
			console.log(file_head2.files[0].lastModified)
            var content = {
                file: file
            }
            this.myUpload(content);
		},
        myUpload(content) {//上传文件到服务器
            this.toast = Toast.loading({
                duration: 0,
                message: '上传中...',
                forbidClick: true,
            });
            let inst = this
            let nowDate = new Date();
            let date = {
                year: nowDate.getFullYear(),
                month: nowDate.getMonth() + 1,
                date: nowDate.getDate(),
            }
            /*文件名加时间戳*/
            let _month = date.month < 10 ? '0'+date.month : date.month
            let _date = date.date < 10 ? '0'+date.date : date.date
            let systemDate = date.year +  _month  +  _date;
            let fileName = date.year+_month+_date+Date.now();
            console.log(content)
            /*截取文件类型*/ 
            let fileType = (content.file.name).slice((content.file.name).lastIndexOf('.')+1,content.file.name.length);

            if (!this.ext.includes(fileType)) {
                this.loading = false;
                Toast(`不支持${fileType}类型文件上传`);
                return
            }
            switch(fileType){
                case 'jpg': case 'png': case 'gif': case 'jpeg': case 'bmp':
                    inst.fileType = 2;
                break
                default:
                    inst.fileType = 1;
                break;
            }
            /**/
            
            inst.dataList.push({
                loading:true,
                percentage:0,
                name:content.file.name,
                uid:content.file.uid
            });
            
            /*分片上传的进度*/ 
            const progress = (p, _checkpoint) => {
                // Object的上传进度。
                // console.log(p);
                // console.log(_checkpoint); // 分片上传的断点信息。
                inst.dataList.forEach(e => {
                    if(_checkpoint && _checkpoint.file.uid == e.uid){
                        e.percentage = Number((p*100).toFixed(0));
                    }
                })
            };
           
            async function multipartUpload() {
                try {
                    // object-name可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
                    const result = await inst.client.multipartUpload('xmerp/xmfiles/'+ date.year + '/' + _month + '/' + _date + '/' + fileName + '.' + fileType, content.file, {
                        progress,
                        // meta是用户自定义的元数据，通过head接口可以获取到Object的meta数据。
                        meta: {
                            year: 2020,
                            people: 'test',
                        },
                    });
                    
                    const head = await inst.client.head('xmerp/xmfiles/'+ date.year + '/' + _month + '/' + _date + '/' + fileName + '.' + fileType );
                    console.log('h----',head);
                    // console.log(result);


                    /*获取文件类型*/
                    let iconUrl;
                    let hz = inst.getCaption(head.res.requestUrls[0],1)
                    switch(hz){
                        case 'xls': case 'xlsx':
                            iconUrl='http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/xls.png'
                        break
                        case 'doc': case 'docx':
                            iconUrl='http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/word.png'
                        break
                        case 'ppt': case 'pptx':
                            iconUrl='http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/ppt.png'
                        break
                        case 'pdf':
                            iconUrl='http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/pdf.png'
                        break
                        case 'rar': case'zip':
                            iconUrl='http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/zip.png'
                        break
                        case 'jpg': case 'png': case 'gif': case 'jpeg': case 'bmp':
                            iconUrl=head.res.requestUrls[0];
                        break
                        default:
                            iconUrl='http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/tongyong.png'
                        break;
                    }

                    inst.dataList.forEach(e => {
                        if(content.file.uid == e.uid){
                            e.loading = false;
                            e.iconUrl = iconUrl;
                            e.fileSize = head.res.headers['content-length']?head.res.headers['content-length']:0;
                            e.fileFormat = head.res.headers['content-type'];
                            e.fileUrl = head.res.requestUrls[0].replace('http://xmoty.oss-cn-shenzhen.aliyuncs.com','https://xmyun.zhoty.com').replace('https://xmoty.oss-cn-shenzhen.aliyuncs.com','https://xmyun.zhoty.com');
                            e.fileName = iconUrl;
                        }
                    })

                    inst.saveDocFileBatch();
                } catch (e) {
                    // 捕获超时异常。
                    if (e.code === 'ConnectionTimeoutError') {
                        console.log('TimeoutError');
                        // do ConnectionTimeoutError operation
                    }
                    console.log(e);
                }
            }
            multipartUpload();
            
        },
        /*获取文件类型*/ 
        getCaption(obj,state){
            var index=obj.lastIndexOf("\.");
            if(state==0){
                obj=obj.substring(0,index);
            }else {
                obj=obj.substring(index+1,obj.length);
                
                
            }
            return obj;
        },
    }
}
</script>

<style lang="scss" scoped> 
.icon-style{
    width:1rem;
    position: relative;
    margin:0 auto;
    line-height: 0;
    img{
        width:1rem;
        height:1rem;
    }
    .el-progress-circle{
        width:1rem;
        height:1rem;
    }
    i{
        font-size: 30px;
        margin-top: 30%;
    }
    .mask{
        display: none;
        position: absolute;
        top: 0;
        left:0;
        text-align: center;
        background: rgba($color: #ccc, $alpha: 0.8);
        z-index: 1;
        border-radius: 10px;
        width: 1rem;
        height: 1rem;
        vertical-align: middle;
    }
}
.icon-style .div:hover .mask{
     display: block;
}
.upload-demo{
    display: inline-block;
    padding: 5px;
    height: 0.55rem;
    width: 0.55rem;
}
.file-wrapper{
    padding:10px;
}
.file-item{
    // width:148px;
    // height: 148px;
    text-align: center;
    display: inline-block;
    vertical-align: top;
    padding: 5px;
    .name{
        width:100%;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;/*重点，不能用block等其他*/
        -webkit-line-clamp: 2;/*重点IE和火狐不支持*/
        -webkit-box-orient: vertical;/*重点*/
        line-height: 20px;
    }
}
.btn{
    height: 0.4rem;
    text-align: center;
    line-height: .4rem;
    background: red;
    color: #fff;
}
</style>
<style lang="scss">
.upload{
    margin-top: 0.3rem;
    .el-upload--picture-card{
        height: 0.55rem;
        width: 0.55rem;
        background: url('https://xmyun.zhoty.com/resource/xapp-pm/static/image/uploadicon/file-upload-type-doc.png') no-repeat left center/0.55rem 0.55rem;
        border: none;
        line-height: 0;
    }
    .upload-item{
    // width: 0.55rem;
    // padding: 0.1rem;
    text-align: center;
    font-size: 0.14rem;
    .icon{
    //   width: 0.55rem;
      height: 0.55rem;
      padding: 0.05rem;
    }
    .pic1{
      background: url('https://xmyun.zhoty.com/resource/xapp-pm/static/image/uploadicon/file-upload-type-photograph.png') no-repeat center center/0.55rem 0.55rem;
    }
  }
  .text{
      display: inline-block;
      margin-top: 0.6rem;
      color: #000;
  }
  .text2{
      display: inline-block;
      margin-top: 0.7rem;
      font-size: 0.14rem;
  }
  .file {
    width: 0.55rem;
    // height: 0.8rem;
    // padding: 0.05rem;
    position: relative;
    display: inline-block;
    overflow: hidden;
    text-decoration: none;
    text-indent: 0;
    background: url('https://xmyun.zhoty.com/resource/xapp-pm/static/image/uploadicon/file-upload-type-photograph.png') no-repeat top center/0.55rem 0.55rem;
    margin-top: 16px;
    }
    .file2 {
        background: url('https://xmyun.zhoty.com/resource/xapp-pm/static/image/uploadicon/file-upload-type-doc.png') no-repeat top center/0.55rem 0.55rem;
    }
    .file input {
        position: absolute;
        right: 0;
        top: 0;
        opacity: 0;
    }
}

</style>


// WEBPACK FOOTER //
// H5Upload.vue?26522453